<button mat-icon-button type="button" class="dialog-close-button" *ngIf="callStarted" aria-label="Cerrar videollamada" (click)="requestClose()">
    <mat-icon aria-hidden="true">close</mat-icon>
</button>

<h3 mat-dialog-title class="dialog-title" [class.is-precall]="!callStarted">
    <div class="dialog-title-row">
        <div class="dialog-heading">
            <span class="dialog-title-text" *ngIf="!callStarted">
                {{ 'Iniciar videollamada' }}
            </span>

            <span class="dialog-description-videocall" *ngIf="!callStarted">
                Compartí el link con {{ this.case?.patient?.surname + ', ' + this.case?.patient?.name }}
                para que se una desde su celular o computadora.
            </span>
        </div>

    </div>
</h3>

<ng-container *ngIf="!callStarted">
    <mat-dialog-content class="precall-content">
        <p *ngIf="busy">Procesando...</p>
        <p role="alert" *ngIf="error">{{ error }}</p>

        <ng-container *ngIf="session">
            <label class="link-label" for="patient-call-link">
                Link de la videollamada
            </label>

            <div class="link-row">
                <div class="link-field">
                    <mat-icon aria-hidden="true">link</mat-icon>
                    <input
                        id="patient-call-link"
                        aria-label="Enlace para el paciente"
                        readonly
                        [value]="session.link"
                    />
                </div>

                <button
                    mat-stroked-button
                    class="copy-link-button"
                    [cdkCopyToClipboard]="session.link"
                >
                    <mat-icon aria-hidden="true">content_copy</mat-icon>
                    Copiar enlace
                </button>
            </div>
        </ng-container>
    </mat-dialog-content>

    <mat-dialog-actions class="precall-actions">
        <button mat-button class="cancel-button" [disabled]="busy" (click)="cancel()">
            Cancelar
        </button>

        <button
            mat-flat-button
            color="primary"
            [disabled]="busy || !session || connecting"
            (click)="continueToCall()"
        >
            Entrar a la videollamada
        </button>
    </mat-dialog-actions>
</ng-container>

<ng-container *ngIf="callStarted">
    <mat-dialog-content #callContent class="call-content"
        [style.--form-width]="formWidth + 'px'"
        [class.is-resizing]="resizing"
        [class.is-stacked]="panelsStacked"
        [class.form-hidden]="formHidden">
        <section class="video-column">
            <div class="video-layout" [style.margin-right.px]="formHidden ? 8 : 0">
                <div class="call-video-header">
                    <span class="dialog-title-text">
                        Videollamada con {{ this.case?.patient?.surname }}, {{ this.case?.patient?.name }}
                    </span>
                    <span class="call-timer" [style.margin-right.px]="formHidden ? 50 : 0">{{ formattedCallDuration }}</span>
                    <button mat-icon-button type="button"
                        class="call-control-btn show-form-btn"
                        *ngIf="formHidden"
                        aria-label="Mostrar formulario"
                        (click)="showForm()">
                        <mat-icon>description</mat-icon>
                    </button>
                </div>

                <div class="video-stage" [class.is-waiting]="!patientStreamReady" [class.is-ended]="!isCallActive">
                    <div #publisherContainer class="local-video"></div>
                    <div #subscriberContainer class="remote-video"></div>

                    <div *ngIf="patientStreamReady && overlayMessage" class="remote-video-overlay" role="status" aria-live="polite">
                        <span>{{ overlayMessage }}</span>
                    </div>

                    <div
                        *ngIf="!patientStreamReady"
                        class="remote-video-placeholder"
                        role="status"
                        aria-live="polite"
                        [ngSwitch]="callState"
                    >
                        <span *ngSwitchCase="'connecting'">Conectando a la videollamada…</span>
                        <span *ngSwitchCase="'reconnecting'">Se perdió la conexión. Reconectando…</span>

                        <ng-container *ngSwitchCase="'ended'">
                            <span class="call-ended-icon" aria-hidden="true">
                                <mat-icon>call_end</mat-icon>
                            </span>
                            <span class="call-ended-title">La llamada terminó</span>
                            <small>Completá el formulario para registrar la evolución.</small>
                            <button mat-flat-button type="button" class="placeholder-action" (click)="continueToCall()">
                                Volver a llamar
                            </button>
                        </ng-container>

                        <ng-container *ngSwitchCase="'failed'">
                            <span class="call-ended-title">{{ error || 'No se pudo conectar a la videollamada.' }}</span>
                            <small>Podés reintentar o completar el formulario igualmente.</small>
                            <button mat-flat-button type="button" class="placeholder-action" (click)="continueToCall()">
                                Reintentar
                            </button>
                        </ng-container>

                        <ng-container *ngSwitchDefault>
                            <span>{{ waitingMessage }}</span>

                            <div class="waiting-link-row" *ngIf="session">
                                <div class="waiting-link-field">
                                    <mat-icon aria-hidden="true">link</mat-icon>
                                    <span class="waiting-link-text">{{ session.link }}</span>
                                </div>

                                <button
                                    mat-stroked-button
                                    class="copy-link-button waiting-copy-button"
                                    [cdkCopyToClipboard]="session.link"
                                >
                                    <mat-icon aria-hidden="true">content_copy</mat-icon>
                                    Copiar
                                </button>
                            </div>

                            <small>
                                {{ callState === 'waiting'
                                    ? 'La llamada empieza automáticamente cuando el paciente ingrese.'
                                    : 'Si el paciente vuelve a ingresar, la llamada se retoma automáticamente.' }}
                            </small>
                        </ng-container>
                    </div>
                </div>

                <div class="call-controls" *ngIf="isCallActive" role="toolbar" aria-label="Controles de videollamada">
                    <button mat-icon-button type="button" class="call-control-btn"
                        [class.is-off]="!micOn"
                        [attr.aria-label]="micOn ? 'Silenciar micrófono' : 'Activar micrófono'"
                        (click)="toggleMicrophone()">
                        <mat-icon>{{ micOn ? 'mic' : 'mic_off' }}</mat-icon>
                    </button>
                    <button mat-icon-button type="button" class="call-control-btn"
                        [class.is-off]="!cameraOn"
                        [attr.aria-label]="cameraOn ? 'Apagar cámara' : 'Encender cámara'"
                        (click)="toggleCamera()">
                        <mat-icon>{{ cameraOn ? 'videocam' : 'videocam_off' }}</mat-icon>
                    </button>

                    <button mat-icon-button type="button"
                        class="call-control-btn call-control-btn--end"
                        aria-label="Finalizar llamada"
                        (click)="endCall()"
                    >
                        <mat-icon>call_end</mat-icon>
                    </button>
                </div>
            </div>


        </section>

        <div class="column-divider" role="separator" tabindex="0"
            aria-label="Ajustar ancho del formulario"
            aria-orientation="vertical"
            [attr.aria-valuemin]="minFormWidth"
            [attr.aria-valuemax]="maxFormWidth"
            [attr.aria-valuenow]="formWidth"
            [attr.aria-valuetext]="formWidth + ' p\u00edxeles de ancho del formulario'"
            (pointerdown)="startResize($event)"
            (pointermove)="moveResize($event)"
            (pointerup)="stopResize($event)"
            (pointercancel)="stopResize($event)"
            (lostpointercapture)="stopResize($event)"
            (keydown)="resizeWithKeyboard($event)">
            <mat-icon aria-hidden="true">more_vert</mat-icon>
        </div>

        <aside class="form-column"
            [attr.inert]="formHidden ? '' : null">

            <div class="form-header">
                <div class="form-header-text">
                    <h3>{{ confirmedForm ? 'Formulario completo' : 'Formulario de evolución' }}</h3>
                    <p *ngIf="!confirmedForm">Los campos con * son obligatorios</p>
                </div>
                <div class="form-header-hide">
                    <button mat-icon-button type="button" class="form-collapse-btn" aria-label="Ocultar formulario" (click)="hideForm()">
                        <mat-icon>keyboard_tab</mat-icon>
                    </button>
                </div>
            </div>

            <app-json-form-wizard
                [hidden]="!!confirmedForm"
                style="--wizard-footer-align: flex-end"
                [form]="data.form"
                [initialValues]="initialValues"
                [showCancel]="false"
                (submitted)="onFormSubmitted($event)"
            >
            </app-json-form-wizard>

            <section *ngIf="confirmedForm" class="form-summary">
                <div class="form-summary-content">
                    <section *ngFor="let section of confirmedSummary">
                        <h4 class="form-summary-title">{{ section.title }}</h4>
                        <dl class="form-summary-fields">
                            <div *ngFor="let item of section.items" class="form-summary-item">
                                <dt>{{ item.title }}</dt>
                                <dd>{{ item.answer }}</dd>
                            </div>
                        </dl>
                    </section>
                </div>

                <div class="form-summary-actions">
                    <button mat-flat-button type="button" class="placeholder-action" (click)="editForm()">
                        Editar
                    </button>
                    <button mat-flat-button type="button" class="placeholder-action" (click)="requestDiscardForm()">
                        Eliminar
                    </button>
                </div>
            </section>
        </aside>
    </mat-dialog-content>
</ng-container>
